export default __webpack_public_path__ + "static/media/multi-usecase-icon.0580aaae.svg";